// This is a simple functional component for displaying a instruction item.
// It takes in an number, title, and description as props and renders them in a styled container.
// Used on landing page for instructional use for the application
import React from 'react';
import styles from './InstructionItem.module.css'; // Adjust the path as necessary
function InstructionItem({ number, title, description }) {
  return (
    <div className={styles.instructionItem}>
      <div className={styles.stepNumber}>{number}</div>
      <h4 className={styles.stepTitle}>{title}</h4>
      <div className={styles.stepDescription}>{description}</div>
    </div>
  );
}

export default InstructionItem;
